import React, { Component } from "react";
// import { Link } from "react-router-dom";
import { get } from "../../../util/axiosLib";

// components
import Sidemenu from "../../../components/sidemenu";
import Header from "../../../components/dashHeader";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";

//assets

// import Cancel from "../../../assets/svg/other/cancel.svg";
// import Arrow from "../../../assets/svg/icons-new/arrow.svg";
// import Edit from "../../../assets/svg/icons-new/edit.svg";
// import Bank from "../../../assets/svg/icons-new/banks.svg";
// import Refer from "../../../assets/svg/icons-new/refer.svg";

// import Logout from "../../../assets/svg/icons-new/logout.svg";
// import VerificationIcon from "../../../assets/svg/verification.svg";
// import SupportBox from "../../../components/support";

import AccountSidebar from "components/AccountSidebar/AccountSidebar";

//css
import "../../styles/dashboard/Account.css";
import { Heading } from "@chakra-ui/react";
import toLower from "lodash/toLower";

// import constant from "config/constant";

export default class Account extends Component {
  state = {
    unVerifiedShow: true,
    userData: "",
  };

  loadBankDetails = async () => {
    try {
      const token = this.props.token;

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      const getBankReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/account/getBankDetails`,
        headers
      );

      //const userBankData = getBankReq.data.data.bank;

      this.setState({
        userBankData: getBankReq.data.data.bank,
        isLoaded: true,
      });

      const userBankData = JSON.stringify(getBankReq.data.data.bank);
      localStorage.setItem("userBankData", userBankData);

      return Promise.resolve(true);
    } catch (err) {
      const errData = err.error;

      if (toLower(errData).includes("token invalid")) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ tokenError: "Token expired, please login again." });

        setTimeout(() => {
          window.location = "/";
        }, 2000);
      }
      return Promise.reject(err);
    }
  };

  componentDidMount() {
    // const token = localStorage.getItem("tokenset");
    // const userData = JSON.parse(localStorage.getItem("btm_user"));
    localStorage.setItem("changePinStatus", false);

    this.setState({
      userData: this.props.userData,
    });
  }

  render() {
    const currentPage = "Account";

    return (
      <div>
        <Sidemenu currentPage={currentPage} logoutUser={this.props.logout} />
        <Header />
        <section>
          <div className="account-container">
            <div className="account-content">
              <div className="account-top">
                <Heading>Account</Heading>
              </div>
              <div
                id="error-info2"
                className="err-auth zindex animate__animated animate__slideInDown"
              >
                <p>
                  <strong>{this.state.tokenError}</strong>
                </p>
              </div>
              <div className="account-sections">
                <div className="account-section-left">
                  <div className="asl-content">
                    {/* <div className="asl-profile-box">
                      <ProfileShortInfo
                        fullName={this.state?.userData?.fullName}
                        verified={this.state?.userData?.verified}
                        kycLevel={this.state?.userData?.kycLevel}
                      />
                    </div> */}
                    <div className="asl-actions">
                      <AccountSidebar
                        userData={this.props.userData}
                        logout={this.props.logout}
                      />

                      {/* <Link
                        to="/dashboard/account/edit"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Edit} alt="edit" />
                          <p>Edit Profile </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}

                      {/* <Link
                        to="/dashboard/account/banks"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Bank} alt="edit" />
                          <p>Banks and Cards </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}
                      {/* <Link
                        to="/dashboard/account/verification"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img
                            className="right-m2"
                            src={VerificationIcon}
                            alt="edit"
                          />
                          <p>Verification</p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}
                      {/* <Link
                        to="/dashboard/account/refer"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Refer} alt="edit" />
                          <p>Refer a friend </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}

                      {/* <SupportBox />
                      <button
                        onClick={() => {
                          this.props.logout();
                          // window.location = constant.PAGES.LOGIN;
                        }}
                        style={{ width: "100%" }}
                      >
                        <Link
                          to="/"
                          className="asl-action-single2"
                          style={{ width: "100%" }}
                        >
                          <div className="asl-action-desc">
                            <img className="right-m2" src={Logout} alt="edit" />
                            <p>Log out </p>
                          </div>
                        </Link>
                      </button> */}
                    </div>
                  </div>
                </div>
                <div className="account-section-right"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
